module.exports = __webpack_public_path__ + "img/logo.ed023f59.png";